import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "btn-shape",
  "use": "btn-shape-usage",
  "viewBox": "0 0 195 51",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 195 51\" id=\"btn-shape\">\n    <path fill-rule=\"evenodd\" d=\"M163.820,50.607 L9.199,50.607 C4.242,50.607 0.224,46.602 0.224,41.661 L0.224,9.000 C0.224,4.060 4.242,0.054 9.199,0.054 L163.820,0.054 C165.800,0.054 167.719,0.734 169.256,1.978 L192.317,20.653 C195.296,23.065 195.296,27.597 192.317,30.009 L169.256,48.683 C167.719,49.928 165.800,50.607 163.820,50.607 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol